import * as XLSX from "xlsx";

export const exportExcelData = (data, sheetName, fileName) => {
    var wb = XLSX.utils.book_new(),
    ws = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    XLSX.writeFile(wb, fileName);
}